import React, {Component} from "react";
import UndoRedo from "./UndoRedo";
import System from "./System";
import withErrorBoundary from "../../decorators/withErrorBoundary";

export class SystemControl extends Component {
  render() {
    return (
      <div className="panel-control panel-control_system">
        <div className="panel-control__content">
          <UndoRedo />
          <System />
        </div>
      </div>
    );
  }
}

export default withErrorBoundary(SystemControl);
